/** Locale list + hreflang codes for the abroad cluster (tiny, safe to load eagerly). */
export const ABROAD_LOCALES = ["en", "zh", "ja", "ko", "vi", "id"] as const;
export type AbroadLocale = (typeof ABROAD_LOCALES)[number];

export const ABROAD_HREFLANG: Record<AbroadLocale, string> = {
  en: "en",
  zh: "zh-CN",
  ja: "ja",
  ko: "ko",
  vi: "vi",
  id: "id",
};
